import styled from 'styled-components'
import { Form } from 'formik'

import { RegularModerate } from 'components/Typography'
import theme from 'theme_'

export const LoginContainer = styled.div`
  position: relative;
  display: block;

  @media ${theme.devices.desktop} {
    display: flex;
  }
`

export const StyledLoginForm = styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 347px;
  padding: 5px;

  @media ${theme.devices.tablet} {
    max-width: 471px;
    padding: 0;
  }
`

export const StyledDescriptionText = styled(RegularModerate)`
  margin: 0 auto ${theme.spacing.sm};
  width: 80%;
  text-align: center;
`

export const CheckMarkWrapper = styled.div`
  margin: 0 0 32px;
  display: flex;
  justify-content: center;
  align-items: center;
`
